// extracted by mini-css-extract-plugin
export default {"placeholder":"dropdown_placeholder__QcQPs","menu":"dropdown_menu__LN4pW","control":"dropdown_control__JvGoS","lg":"dropdown_lg__KUAes","right":"dropdown_right__CvzEO"};